export const tableData = (data) => {
  const columns = [
    // { field: "id", headerName: "ID", hide: true },
    {
      field: "nombre_completo_denunciante",
      headerName: "Denunciante",
      minWidth: 250,
      flex:1
      
    },
    {
      field: "documento_denunciante",
      headerName: "# Documento",
      minWidth: 150,
      flex:1
    },
    {
      field: "fecha_hora",
      headerName: "Fecha y Hora",
      minWidth: 175,
      flex:1
    },
    {
      field: "tipo_infraccion",
      headerName: "Tipo de Infracción",
      minWidth: 150,
      flex:1
    },
  ];

  const rows = data.map((d, index) => {
    return {
      id: d.id,
      nombre_completo_denunciante: d?.usuario?.nombre_completo,
      documento_denunciante: d?.usuario?.dni,
      denunciante: d?.usuario,
      fecha_hora: d.fecha_hora,
      tipo_infraccion: d.tipo_infraccion,
      latitud: d?.latitud,
      longitud: d?.longitud,
      estado_id: d?.estado_id,
    };
  });

  const filter = (d, value) => {
    value = value.toLowerCase();
    return (
      String(d.nombre_completo_denunciante)?.toString().toLowerCase().includes(value) ||
      String(d.equipo)?.toString().toLowerCase().includes(value)
    );
  };

  return { columns, rows, filter };
};
